const moduleA = {
  namespaced: true,
  /*数据*/
  state:{
    str:'moduleA str'
  },

  /*计算属性*/
  getters:{

    get_str: state => {
      return state.str + '_计算属性值'
    }

  },

  /*函数（同步）*/
  mutations:{

    set_str: (state,par) => {
      state.str = par
    }

  },

  /*函数（异步）*/
  actions:{

    set_str:(context,par) =>{
      setTimeout(() =>{
        context.state.str = par
      },2000)
    }

  }
}
export default moduleA



// WEBPACK FOOTER //
// ./src/store/modules/moduleA.js